import React from 'react';
import * as styles from './styles.css';
import { TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

export interface IUniqueViewProps {
  adPositionRows: JSX.Element;
  adPositionBlocks: JSX.Element;
  numberInput: JSX.Element;
  device: TDeviceType;
}

export const UniqueView: React.FC<IUniqueViewProps> = ({ adPositionBlocks, adPositionRows, numberInput, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])} data-name="UniqueView">
      <div className={styles['content']}>
        <div className={styles['title']}>Установите ставку за уникальный просмотр</div>
        <div className={styles['text-block']}>
          <div className={styles['text']}>
            Чем больше ставка, тем выше поднимается объявление в результатах поиска и чаще показывается в рекомендациях
            заинтересованным клиентам
          </div>
          <div className={styles['controls']}>{numberInput}</div>
        </div>
        <div className={styles['animated-blocks']}>
          {adPositionRows}
          {adPositionBlocks}
        </div>
      </div>
    </div>
  );
};
